import { useHistory } from "react-router-dom";
import { DropdownButton } from "@jsq/ds/core";

type NewTemplateButtonProps = {
  arenaId: number | null;
  hasTemplates: boolean;
  align?: "left" | "right";
  usePortal?: boolean;
};

export const NewTemplateButton = ({
  arenaId,
  hasTemplates,
  align,
  usePortal,
}: NewTemplateButtonProps) => {
  const history = useHistory();
  const routePrefix = `/reporting/${arenaId ?? "system"}/templates`;

  return (
    <DropdownButton
      label={arenaId != null ? "New custom template" : "New system template"}
      variant="primary"
      align={align}
      usePortal={usePortal}
    >
      <DropdownButton.Action
        disabled={!hasTemplates}
        onSelect={() => history.push(`${routePrefix}/duplicate`)}
      >
        Duplicate from existing
      </DropdownButton.Action>
      <DropdownButton.Action onSelect={() => history.push(`${routePrefix}/new`)}>
        Create a new template
      </DropdownButton.Action>
    </DropdownButton>
  );
};
